import React, { FC } from 'react'

import { IconBirthdayGreetingProps } from './IconBirthdayGreeting.types'
import * as Styled from './styles/IconBirthdayGreeting.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBirthdayGreeting: FC<IconBirthdayGreetingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBirthdayGreetingProps['size'],
  isResponsive = false,
}: IconBirthdayGreetingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#d77b225d-5d34-40b2-af3d-a3b1f8b2f02d__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M24 20.58v-5.777m6 5.082v-6.86' stroke='#E60000' strokeLinejoin='round' />
          <path d='M30 8.993v.722' stroke='#0D0D0D' strokeLinejoin='round' />
          <path d='M18 19.887v-6.86' stroke='#E60000' strokeLinejoin='round' />
          <path d='M18 8.995v.723m6 1.27v.722' stroke='#0D0D0D' strokeLinejoin='round' />
          <path d='M39 21.095H13a4 4 0 0 0-4 4V39.05a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V21.095Z' stroke='#0D0D0D' strokeMiterlimit='10' />
          <path
            d='M9.068 27.945a3.155 3.155 0 0 0 6.112 1.095 3.15 3.15 0 0 0 5.913 0 3.15 3.15 0 0 0 5.912 0 3.15 3.15 0 0 0 5.912 0 3.153 3.153 0 0 0 6.11-1.095'
            stroke='#0D0D0D'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='d77b225d-5d34-40b2-af3d-a3b1f8b2f02d__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBirthdayGreeting
